import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusSquare } from '@fortawesome/pro-regular-svg-icons';
import ChannelService from '@avtechsoftware/ra-javascript-utilities/src/utilities/channels/ChannelService';
import ChannelKey from '@avtechsoftware/ra-javascript-utilities/src/classes/ChannelKey';
import {
  selectRoomAlertDeviceList,
  selectSensorMap,
} from '../../../../redux/slices/deviceList/deviceListSlice';

function AdditionalSensor({ channelKey, onRemove }) {
  const deviceList = useSelector(selectRoomAlertDeviceList);
  const sensorMap = useSelector(selectSensorMap);

  const channelGroupList = sensorMap[channelKey.macAddress] || [];
  const targetDevice = deviceList.find((device) => device.uuid === channelKey.macAddress);
  const deviceName = targetDevice ? targetDevice.displayName : 'UNKNOWN DEVICE';

  const targetSensor = channelGroupList.find((sensor) => `${sensor.channelGroupMacAddress}_${sensor.channelGroupTypeId}_${sensor.channelGroupIndex}` === channelKey.channelGroupIdentifier);
  const sensorName = targetSensor ? targetSensor.label : 'UNKNOWN SENSOR';

  const channelName = ChannelService.getChannelGroupChannel(
    channelKey.channelGroupType, channelKey.channelIndex, channelKey.channelType,
  ).displayName;

  return (
    <div className="d-flex align-items-center mb-2">
      <div
        className="mr-0 text-muted cursor-pointer btn pl-0"
        onClick={onRemove}
        style={{ cursor: 'pointer' }}
        title="Remove"
      >
        <FontAwesomeIcon icon={faMinusSquare} />
      </div>
      <span>
        <i>{deviceName}</i>
        {' > '}
        {sensorName}
        {' > '}
        {channelName}
      </span>
    </div>
  );
}

AdditionalSensor.propTypes = {
  channelKey: PropTypes.instanceOf(ChannelKey).isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default AdditionalSensor;
